export default function WinRateBadge({ value, size = "sm" }) {
  if (value == null) return <span className="text-xs text-muted-foreground">—</span>;
  const cls = value >= 60 ? "text-bull bg-bull/10 border-bull/30"
    : value >= 40 ? "text-neutral bg-neutral/10 border-neutral/30"
    : "text-bear bg-bear/10 border-bear/30";
  const pad = size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-xs";
  return <span className={`inline-block rounded-full border font-semibold font-mono ${pad} ${cls}`}>{value}% win</span>;
}
